import React from 'react';
import './index.scss';
import SpConfOdItem from '../../molecules/SpConfOdItem';

const SpConfTitle = ({
    text,
    list = [],
    icon,
    comment
}) => {
    const svgDir = require.context("!@svgr/webpack!assets/");

    const Icon = svgDir(`./${icon}.svg`).default;

    // const DispIcon = () => {
    //     return (
    //         <span className="">
    //             <img className="icon" src={require(`assets/${icon}.svg`)} alt="" />
    //         </span>
    //     )
    // };

    const ShowList = ({ list: detail }) => {
        return (
            <div className="">
                {detail.map(data => (
                    <span className="">
                        <SpConfOdItem
                            text={data.text}
                            children={data.children}
                            modifyLinks={data.modifyLinks} />
                    </span>
                )
                )}
            </div>
        )
    };

    return (
        <div className="SpConfTitle">
            <div className="SITM-title">
                <div className="SITM-iconArea">
                    {/* <DispIcon /> */}
                    <span className="icon">
                        <Icon/>
                    </span>
                </div>
                <div className="SITM-titleArea">
                    <p className="title"> {text} </p>
                </div>
            </div>
            <div className="SITM-item">
                <ShowList list={list} />
            </div>
            <div className="commentArea">
                {comment}
            </div>
            <div className="horizontalLine"></div>
        </div>
    );
};

export default SpConfTitle;